import React, {FC, ReactElement} from 'react';
import styles from './index.module.scss';
import {useTranslation} from "react-i18next";

interface Props {
    onClose: () => void
}

const TipsModal: FC<Props> = ({onClose}): ReactElement => {
    const {t} = useTranslation();
    return (
        <div className={styles.modal}>
            <div className={styles.overlayCss} onClick={() => onClose()}></div>
            <div className={styles.contentCss}>
                <div style={{padding: '0.16rem'}}>
                    <p>{t('home.ensureDetai')}</p>
                    <p style={{marginTop: '0.08rem'}}>{t('home.noteCorrect')}</p>
                </div>

                <div className={styles.line}></div>
                <div className={styles.confirm} onClick={() => onClose()}>{t('home.Acknowledged')}</div>
            </div>
        </div>
    )
}

export default TipsModal
